import { render, staticRenderFns } from "./Posters.vue?vue&type=template&id=b3ab93d4"
import script from "./Posters.vue?vue&type=script&lang=js"
export * from "./Posters.vue?vue&type=script&lang=js"
import style0 from "./Posters.vue?vue&type=style&index=0&id=b3ab93d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports